import { Link } from "react-router-dom";
import { Sparkles, Twitter, Github, Linkedin, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          {/* Brand and Description */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 bg-gradient-to-r from-purple-600 to-blue-600 rounded-lg flex items-center justify-center">
                <Sparkles className="w-5 h-5 text-white" />
              </div>
              <span className="text-xl font-bold">PromptPerfect</span>
            </div>
            <p className="text-gray-400 mb-6 max-w-md">
              Transform your ideas into perfect prompts. The ultimate AI prompt engineering platform for creators, developers, and businesses.
            </p>
            <div className="flex space-x-4">
              <Button variant="ghost" size="icon" className="hover:text-purple-500">
                <Twitter className="w-5 h-5" />
              </Button>
              <Button variant="ghost" size="icon" className="hover:text-purple-500">
                <Github className="w-5 h-5" />
              </Button>
              <Button variant="ghost" size="icon" className="hover:text-purple-500">
                <Linkedin className="w-5 h-5" />
              </Button>
            </div>
          </div>

          {/* Product Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Product</h3>
            <ul className="space-y-3">
              <li><Link to="/features" className="text-gray-400 hover:text-purple-400">Features</Link></li>
              <li><Link to="/pricing" className="text-gray-400 hover:text-purple-400">Pricing</Link></li>
              <li><Link to="/examples" className="text-gray-400 hover:text-purple-400">Examples</Link></li>
              <li><Link to="/integrations" className="text-gray-400 hover:text-purple-400">Integrations</Link></li>
              <li><Link to="/changelog" className="text-gray-400 hover:text-purple-400">Changelog</Link></li>
            </ul>
          </div>

          {/* Resources Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Resources</h3>
            <ul className="space-y-3">
              <li><Link to="/docs" className="text-gray-400 hover:text-purple-400">Documentation</Link></li>
              <li><Link to="/api" className="text-gray-400 hover:text-purple-400">API Reference</Link></li>
              <li><Link to="/blog" className="text-gray-400 hover:text-purple-400">Blog</Link></li>
              <li><Link to="/support" className="text-gray-400 hover:text-purple-400">Support</Link></li>
              <li><Link to="/community" className="text-gray-400 hover:text-purple-400">Community</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-sm">
              © 2024 PromptPerfect. All rights reserved.
            </div>
            <div className="flex space-x-6 text-sm">
              <Link to="/privacy" className="text-gray-400 hover:text-purple-400">Privacy Policy</Link>
              <Link to="/terms" className="text-gray-400 hover:text-purple-400">Terms of Service</Link>
              <Link to="/cookies" className="text-gray-400 hover:text-purple-400">Cookie Policy</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;